
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
name: "QuizInputView",
created() {},
mounted() {



},
props: ["question"],
data() {
return {
answer: ""
};
},
methods: {
submit: function() {
let answer = (this.answer || "").trim();

if (answer == "") {
this.$vux.toast.text("答案不能为空", "middle");
return;
}

this.$emit("answer", answer);
}
},
watch: {
question: function() {
this.answer = null;
}
},
components: {
XInput,
Group
}
};



// WEBPACK FOOTER //
// ./src/components/quiz/quiz_question/QuizInputView.vue